import { createSlice } from "@reduxjs/toolkit";

const fabricSlice = createSlice({
  name: "fabric",
  initialState: {
    canvas: {},
    canvases: {},
    imageId: "",
    imageIds: {},
    frameCanvas: "",
    nodes: 1,
    error: {
      active: false,
      message: "",
    }
  },
  reducers: {
    saveCanvasPointer(state, action) {
      let { canvasPointer, node } = action.payload;
      if (node) {
        state.canvases = { ...state.canvases, [node]: canvasPointer };
      } else {
        state.canvas = canvasPointer;
      }
    },
    saveFrameCanvasPointer(state, action) {
      state.frameCanvas = action.payload;
    },
    saveImageId(state, action) {
      let { imgId, node } = action.payload;
      if (node) {
        state.imageIds = { ...state.imageIds, [node]: imgId };
      } else {
        state.imageId = imgId;
      }
    },
    saveNodes(state, action) {
      state.nodes = action.payload;
    },
    setError(state, action) {
      let { active, message } = action.payload;
      state.error = {active, message};
    },
  },
});

export const {
  saveCanvasPointer,
  saveFrameCanvasPointer,
  saveImageId,
  saveNodes,
  setError
} = fabricSlice.actions;
export default fabricSlice.reducer;
